class HeaderPrimary {

  constructor(){
		this.body    = document.querySelector('body');
		this.trigger = document.querySelectorAll('[data-trigger="header-primary"]');
		this.target  = document.querySelector('[data-target="header-primary"]');

		if(this.target){
			this._init();
		}
	}

	_init(){
    for (let element of this.trigger) {
      element.addEventListener('click', (event)=> this._toggleNav(event) );
    }
	}

	_toggleNav(event){
		this._toggleState(this.body, 'locked-for-header-primary', 'unlocked');
		this._toggleState(this.target, 'open', 'closed');
		this._toggleState(event.currentTarget, 'open', 'closed');
	}

	_toggleState(elem, one, two){
		const newState = elem.getAttribute('data-state') === one ? two : one;
  	elem.setAttribute('data-state', newState);
	}
}
  
export let headerPrimary = new HeaderPrimary();